import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAddVideoMutation } from "../../../features/Videos/videosApi";
import routes from "../../../config/routeConfig";
import VideoForm from "./VideoForm";

const initialState = {
  title: "",
  description: "",
  url: "",
  views: "",
  duration: "",
};

export default function AddVideoForm() {
  const navigate = useNavigate();
  const [formValues, setFormValues] = useState(initialState);
  const [addVideo, { isSuccess, isError, error }] = useAddVideoMutation();

  const handleSubmit = (e) => {
    e.preventDefault();
    const { title, description, url, views, duration } = formValues;
    const createdAt = new Date().toISOString();

    addVideo({
      title,
      description,
      url,
      views: `${views}K`,
      duration,
      createdAt,
    });
  };

  useEffect(() => {
    if (isSuccess) {
      setFormValues(initialState);
      navigate(routes.admin.videos, { replace: true });
    } else if (isError) {
      alert(error?.data);
    }
  }, [isError, isSuccess]);

  return (
    <VideoForm
      formValues={formValues}
      setFormValues={setFormValues}
      handleSubmit={handleSubmit}
    />
  );
}
